const OFFSET_PREVIOUS_ELEMENT = 2
const horizontalDimensions = ['x', 'width']
const verticalDimensions = ['y', 'height']
const QUOTED_REGEX = /^"(.*)"$/

export const uniqueComponentKey = (type, id, extra) => `${type}.${id}` + (extra ? `.${extra}` : '')
export const splitComponentKey = (key) => (Array.isArray(key) ? key : key.split('.'))
export const reverseUniqueComponentKey = (key) => {
  const [type, id, subtype] = splitComponentKey(key)
  return { type, id, subtype }
}

export const isValidInput = (inputValue) => {
  const validNumber = /^[0-9]\d*(\.\d+)?$/.test(inputValue)
  return validNumber
}

export const isSameRect = (rectA, rectB) =>
  ['x', 'y', 'width', 'height'].every((dimension) => rectA[dimension] == rectB[dimension])

export const convertToPixels = (percent, maxPixels) => (+percent * maxPixels) / 100

export const convertToPerc = (pixels, maxPixels) => (pixels * 100) / maxPixels

export const chooseMaxPixels = (dimension, width, height) => (horizontalDimensions.includes(dimension) ? width : height)

export const capitalizeWord = (word) => {
  return word.charAt(0).toUpperCase() + word.slice(1)
}

export const calNewRectDuplicateEl = ({ rect, page }) => {
  // determine if new duplicate elements are overflowing at the bottom of the page
  let isOverBottomPage = false
  const selectedEls = document.getElementsByClassName('draw-area-selected')
  const drawAreaEl = document.getElementsByClassName('draw-area-component')

  for (let selectedEl of selectedEls) {
    const offsetYnewElement =
      selectedEl.offsetHeight + OFFSET_PREVIOUS_ELEMENT + selectedEl.getBoundingClientRect().bottom
    if (offsetYnewElement > drawAreaEl[page].getBoundingClientRect().bottom || offsetYnewElement > window.innerHeight) {
      isOverBottomPage = true
      break
    }
  }
  const newY = isOverBottomPage ? -(OFFSET_PREVIOUS_ELEMENT + rect.height) : OFFSET_PREVIOUS_ELEMENT + rect.height

  return { ...rect, y: rect.y + newY }
}

export const getTemplatePathChanges = (prePaths, curPaths) => {
  const pathsRemoved = new Set()
  const pathsAdded = new Set()
  const curTemplatePaths = new Set(curPaths)
  const preTemplatePaths = new Set(prePaths)
  for (let e of curTemplatePaths) {
    if (!preTemplatePaths.has(e)) pathsAdded.add(e)
  }
  for (let e of preTemplatePaths) {
    if (!curTemplatePaths.has(e)) pathsRemoved.add(e)
  }
  return [pathsRemoved, pathsAdded]
}

export function findAndUpdateNode(nodes, itemId, updateData) {
  for (let i = 0; i < nodes.length; i++) {
    const item = nodes[i]

    if (item.id === itemId) {
      const updatedItem = { ...item, ...updateData }
      nodes[i] = updatedItem
      return updatedItem
    }

    if (item.nodes && item.nodes.length > 0) {
      const foundItem = findAndUpdateNode(item.nodes, itemId, updateData)
      if (foundItem) return foundItem
    }
  }

  return null
}

export function extractAllSections(nodes) {
  let allSections = []

  for (const node of nodes) {
    if (node.type === 'section') {
      allSections.push(node)
    }
    if (node.nodes && Array.isArray(node.nodes) && node.nodes.length > 0) {
      const nestedSections = extractAllSections(node.nodes)
      allSections = allSections.concat(nestedSections)
    }
  }

  return allSections
}

export function findSectionFromField(nodes, fieldName, closestAncestorSection = null) {
  for (const node of nodes) {
    if (node.type === 'section') {
      const foundSection = findSectionFromField(node.nodes || [], fieldName, node)
      if (foundSection) {
        return foundSection
      }
    } else if (node.type === 'question') {
      if (node.question_attributes && node.question_attributes?.field === fieldName) {
        return closestAncestorSection
      }
    } else if (node.nodes && Array.isArray(node.nodes) && node.nodes.length > 0) {
      const foundSection = findSectionFromField(node.nodes, fieldName, closestAncestorSection)
      if (foundSection) {
        return foundSection
      }
    }
  }

  return null
}

export function findQuestionFromField(nodes, fieldName) {
  for (const node of nodes) {
    if (node.type === 'question') {
      if (node.question_attributes && node.question_attributes?.field === fieldName) {
        return node
      }
    } else if (node.nodes && Array.isArray(node.nodes) && node.nodes.length > 0) {
      const foundQuestion = findQuestionFromField(node.nodes, fieldName)
      if (foundQuestion) {
        return foundQuestion
      }
    }
  }

  return null
}

export function findAndRemoveQuestionFromPath(nodes, path) {
  for (let i = 0; i < nodes.length; i++) {
    const item = nodes[i]
    if (item?.question_attributes?.field === path) {
      return nodes.splice(i, 1)[0]
    }
    if (item.nodes && item.nodes.length > 0) {
      const foundItem = findAndRemoveQuestionFromPath(item.nodes, path)
      if (foundItem) return foundItem
    }
  }
  return null
}

export function findAndRemoveNode(nodes, itemId) {
  for (let i = 0; i < nodes.length; i++) {
    const item = nodes[i]
    if (item.id === itemId) {
      return nodes.splice(i, 1)[0]
    }
    if (item.nodes && item.nodes.length > 0) {
      const foundItem = findAndRemoveNode(item.nodes, itemId)
      if (foundItem) return foundItem
    }
  }
  return null
}

export function findAndInsertNode(nodes, parentId, itemToInsert, index) {
  if (parentId === null) {
    nodes.splice(index, 0, itemToInsert)
    return true
  }
  for (const item of nodes) {
    if (item.id === parentId) {
      if (!item.nodes) item.nodes = []
      item.nodes.splice(index, 0, itemToInsert)
      return true
    }
    if (item.nodes && item.nodes.length > 0) {
      const inserted = findAndInsertNode(item.nodes, parentId, itemToInsert, index)
      if (inserted) return true
    }
  }
  return false
}

export function exportPathsFromHtmlNodes(nodes) {
  let listPath = []
  for (const item of nodes) {
    const type = item.type
    if (type === 'question' && item?.question_attributes?.field) {
      listPath.push(item?.question_attributes?.field)
    }
    if (item.nodes && item.nodes.length > 0) {
      const paths = exportPathsFromHtmlNodes(item.nodes)
      listPath = listPath.concat(paths)
    }
  }
  return listPath
}

export function replaceLabelWithParentPath(nodes, sectionId, question) {
  for (const item of nodes) {
    if (item.id === sectionId) {
      item.type = 'question'
      item.asSubSection = true
      if (question) item.question_attributes = question.question_attributes
      delete item.section_attributes
      return
    }
    if (item.nodes && item.nodes.length > 0) replaceLabelWithParentPath(item.nodes, sectionId, question)
  }
  return
}

export function replaceParentPathWithLabel(nodes, question) {
  for (const item of nodes) {
    if (item.id === question.id) {
      item.type = 'section'
      item.section_attributes = {
        label: 'sub-section title',
      }
      delete item.question_attributes
      delete item.asSubSection
      return
    }
    if (item.nodes && item.nodes.length > 0) replaceParentPathWithLabel(item.nodes, question)
  }
  return
}

export function findQuestion(nodes, questionId) {
  for (const item of nodes) {
    if (item.id === questionId) return item
    if (item.nodes && item.nodes.length > 0) {
      const question = findQuestion(item.nodes, questionId)
      if (question) return question
    }
  }
}

export function parseDndId(idString) {
  if (!idString) return { type: null, id: null }
  const [type, ...idParts] = idString.split('.')
  const id = idParts.join('.')
  return { type, id }
}

const parseArgs = (rawArgs) => {
  const parts = rawArgs.split(',').map((s) => s.trim())
  const values = []
  let delimiter = ' ' // Default

  for (const item of parts) {
    if (QUOTED_REGEX.test(item)) {
      delimiter = item.slice(1, -1)
    } else {
      values.push(item)
    }
  }
  return { values, delimiter }
}

const getMacroExpansion = (macro, path) => {
  const MAP = {
    name: {
      func: 'template',
      template: '{{0}} {{1}} {{2}}',
      values: [`${path}.first_name`, `${path}.middle_name`, `${path}.last_name`],
    },
    address: {
      func: 'template',
      template: '{{0}}, {{1}}, {{2}} {{3}}',
      values: [`${path}.street_address`, `${path}.city`, `${path}.state`, `${path}.zip`],
    },
    money: { func: 'money', value: path },
    date: {
      func: 'template',
      template: '{{0}} {{1}}, {{2}}',
      values: [
        { func: 'month_name', value: path },
        { func: 'date_with_suffix', value: path },
        { func: 'year', value: path },
      ],
    },
    concat: () => {
      const { values, delimiter } = parseArgs(path)
      return { func: 'concat', values: values, delimiter: delimiter }
    },
  }

  const entry = MAP[macro]
  return typeof entry === 'function' ? entry() : entry || null
}

export function expandTemplate(input) {
  const trimmed = input?.trim()
  if (!trimmed) return input

  // 1. Shorthand Macros (@macro(args))
  const macroMatch = trimmed.match(/^@(\w+)\((.+)\)$/)
  if (macroMatch) {
    return getMacroExpansion(macroMatch[1], macroMatch[2])
  }

  // 2. Multi-line Logic
  const lines = trimmed
    .split('\n')
    .map((l) => l.trim())
    .filter(Boolean)

  if (lines.length > 1) {
    return {
      func: 'template',
      template: lines.map((_, i) => `{{${i}}}`).join(' '),
      values: lines,
    }
  }

  // 3. Default: Single path
  return [trimmed]
}
